import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

export const ThreadItemContainer = superstyled({
  name: 'ThreadListItem',
  slot: 'Container',
  tag: Box,
  propsNeeded: ['isActive'],
  styles: ({ theme, isActive }) => ({
    position: 'relative',
    padding: `${theme.spacing(1)} ${theme.spacing(1.5)}`,
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    color: theme.palette.text.white,
    backgroundColor: isActive ? 'rgba(255,255,255,0.1)' : 'transparent',
    border: isActive ? `1px solid ${theme.palette.primary.main}` : '1px solid transparent',
    borderRadius: '0.5rem',

    '&:hover': {
      backgroundColor: isActive ? 'rgba(255,255,255,0.1)' : 'rgba(255,255,255,0.1)',

      // Show edit button on hover
      '& [data-edit-button]': {
        opacity: 0.7
      }
    },

    '&:focus': {
      outline: `0 solid transparent`,
      outlineOffset: '0'
    }
  })
});

export const ThreadContent = superstyled({
  name: 'ThreadListItem',
  slot: 'Content',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    width: '100%'
  })
});

export const ThreadHeader = superstyled({
  name: 'ThreadListItem',
  slot: 'Header',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(1)
  })
});

export const ThreadTitle = superstyled({
  name: 'ThreadListItem',
  slot: 'Title',
  tag: Text,
  propsNeeded: ['isActive'],
  styles: ({ theme, isActive }) => ({
    color: isActive ? theme.palette.text.white : theme.palette.text.white,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: 1,
    minWidth: 0 // Allows text truncation
  })
});

export const ThreadTime = superstyled({
  name: 'ThreadListItem',
  slot: 'Time',
  tag: Text,
  styles: ({ theme }) => ({
    marginLeft: theme.spacing(1)
  })
});

export const ThreadMeta = superstyled({
  name: 'ThreadListItem',
  slot: 'Meta',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1)
  })
});

export const ThreadDate = superstyled({
  name: 'ThreadListItem',
  slot: 'Date',
  tag: Text,
  styles: () => ({
    flexShrink: 0
  })
});

export const MessageCount = superstyled({
  name: 'ThreadListItem',
  slot: 'MessageCount',
  tag: Text,
  styles: ({ theme }) => ({
    padding: `${theme.spacing(0.25)} ${theme.spacing(0.75)}`,
    borderRadius: theme.shape.borderRadius,
    flexShrink: 0
  })
});

export const EditButton = superstyled({
  name: 'ThreadListItem',
  slot: 'EditButton',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    padding: theme.spacing(0.5),
    borderRadius: '4px',
    transition: 'all 0.2s ease-in-out',
    opacity: 0, // Hidden by default
    flexShrink: 0,
    marginLeft: theme.spacing(0.5),

    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.1)'
    },

    '& svg': {
      fontSize: '1rem',
      color: theme.palette.text.white
    }
  })
});

export const TitleInput = superstyled({
  name: 'ThreadListItem',
  slot: 'TitleInput',
  tag: 'input',
  styles: ({ theme }) => ({
    flex: 1,
    minWidth: 0,
    background: 'rgba(255,255,255,0.1)',
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: '4px',
    padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
    color: theme.palette.text.white,
    fontSize: 'inherit',
    fontFamily: 'inherit',
    outline: 'none',

    '&::placeholder': {
      color: 'rgba(255,255,255,0.5)'
    }
  })
});
